/* ============ Styrkeprøven: dobbelt high score (all time + måned) ============
   Tredje kopi af punchboard-mønstret (kopieret, ikke delt — spillene må
   divergere): ALLE gennemførte spil indsendes, max 3 pr. bruger pr. liste,
   håndhævet ved lagring (pruning til top 3 all time + top 3 denne
   måned, max 6 pr. enhed) og visning. Score = hammer-total 0-1000. */

import { getName } from "./profile.js";
import { deviceId } from "./board.js";

const DB = "https://carnival-dk-default-rtdb.europe-west1.firebasedatabase.app";
const PATH = "hammer";
const PER_USER = 3;
const LIST_LEN = 10;

const monthKey = (ts) => {
  const d = new Date(ts);
  return d.getFullYear() * 100 + (d.getMonth() + 1);
};
const byScore = (a, b) => b.score - a.score || a.ts - b.ts;

export async function submitHammerScore(score) {
  const name = getName();
  if (!name || !Number.isFinite(score) || score <= 0) return false;
  try {
    const dev = deviceId();
    const r0 = await fetch(`${DB}/${PATH}/${dev}.json`);
    const cur = (r0.ok ? await r0.json() : null) || {};
    const entries = Object.entries(cur).map(([id, e]) => ({ id, ...e }));
    entries.push({
      id: "s" + Date.now().toString(36) + Math.random().toString(36).slice(2, 6),
      name, score: Math.round(score), ts: Date.now(),
    });
    const sorted = [...entries].sort(byScore);
    const nowM = monthKey(Date.now());
    const keep = new Set(sorted.slice(0, PER_USER).map((e) => e.id));
    sorted.filter((e) => monthKey(e.ts) === nowM).slice(0, PER_USER).forEach((e) => keep.add(e.id));
    const outObj = {};
    for (const e of entries) {
      if (keep.has(e.id)) outObj[e.id] = { name: e.name, score: e.score, ts: e.ts };
    }
    const r = await fetch(`${DB}/${PATH}/${dev}.json`, {
      method: "PUT",
      body: JSON.stringify(outObj),
    });
    return r.ok;
  } catch { return false; }
}

export async function fetchHammerBoard() {
  const r = await fetch(`${DB}/${PATH}.json`);
  if (!r.ok) throw new Error("hammer board fetch failed");
  const data = (await r.json()) || {};
  const me = deviceId();
  const rows = [];
  for (const [dev, entries] of Object.entries(data)) {
    for (const e of Object.values(entries || {})) {
      if (e && typeof e.score === "number") {
        rows.push({ dev, name: e.name || "?", score: e.score, ts: e.ts || 0, me: dev === me });
      }
    }
  }
  const top = (list) => {
    const sorted = [...list].sort(byScore);
    const perDev = {};
    const out = [];
    for (const e of sorted) {
      perDev[e.dev] = (perDev[e.dev] || 0) + 1;
      if (perDev[e.dev] <= PER_USER) out.push(e);
      if (out.length >= LIST_LEN) break;
    }
    return out;
  };
  const nowM = monthKey(Date.now());
  return {
    alltime: top(rows),
    month: top(rows.filter((e) => monthKey(e.ts) === nowM)),
  };
}
